export default "__VITE_ASSET__88fb0eac__"